var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{attrs:{"fieldNames":{ label: 'name', value: 'name', children: 'children' },"options":_vm.areaData,"placeholder":"请选择省市区"},on:{"change":_vm.onChange},model:{value:(_vm.selectedValues),callback:function ($$v) {_vm.selectedValues=$$v},expression:"selectedValues"}})
}
var staticRenderFns = []

export { render, staticRenderFns }